import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { Toggle } from "@tandemdiabetes/sugarmate-react-components"
import type { ChangeEvent } from "react"
import {
  useCallback,
  useMemo,
} from "react"
import { useInputPropsForValue } from "src/hooks"

interface Props {
  disabled?: boolean;
  sugarmateAlert: Alert;
  phone: Phone;
  updateAlert: (settings: Partial<Alert>) => void;
}

export const phoneNumberToggleId = "alert-phone-toggle"

export function PhoneNumberToggle(props: Props) {
  const {
    disabled,
    sugarmateAlert,
    phone,
    updateAlert,
  } = props

  const adapter = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => e.target.checked,
    [],
  )

  const onValueChange = useCallback(
    (isEnabled: boolean) => {
      const newPhoneIds = isEnabled
        ? [
          ...sugarmateAlert.phone_ids,
          phone.id,
        ]
        : sugarmateAlert.phone_ids.filter((phoneId) => phoneId !== phone.id)

      const uniquePhoneIds = [...new Set(newPhoneIds)]

      updateAlert({
        phone_ids: uniquePhoneIds,
      })
    },
    [
      sugarmateAlert,
      updateAlert,
      phone,
    ],
  )

  const checked = useMemo(
    () => sugarmateAlert.phone_ids.includes(phone.id),
    [
      sugarmateAlert,
      phone,
    ],
  )

  const {
    value,
    onChange,
  } = useInputPropsForValue({
    value: checked,
    onChange: onValueChange,
    adapter,
    updatedAt: sugarmateAlert.updated_at,
  })

  return (
    <Toggle
      disabled={disabled}
      id={phoneNumberToggleId}
      checked={value}
      onChange={onChange}
    />
  )
}
